import http from "../constant/api";

export const attachmentService = {
  listAttachmentByMessageId: async (messageId) => {
    const result = await http.get(
      `/api/attachment/message-id/${messageId}/list`
    );

    return result;
  },
  queryAttachmentBySessionId: async (sessionId, filter) => {
    const result = await http.get(
      `/api/attachment/session-id/${sessionId}/query`,
      {
        params: filter,
      }
    );

    return result;
  },
};
